"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dataTypeOf = void 0;
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.replace.js");
/** 判断数据类型
 * @description: 判断数据类型
 * @param { * } data 数据
 * @param { Boolean } isObjectCell 是否需要精确判断对象的类型，默认：否
 * @return { void }
 */
var dataTypeOf = exports.dataTypeOf = function dataTypeOf(data, isObjectCell) {
  var a;
  /* 判断当前数据是否需要返回精准的对象类型 */
  if (isObjectCell) {
    a = Object.prototype.toString.call(data);
  } else {
    var _Object$prototype$toS;
    /** Object.prototype.toString.call(data) 获取精准对象类型
     * .replace(/\[|]/g, '') 去掉字符串中的前后 中括号
     * .split(' ')[1] 通过括号打断字符串，获取第二个元素
     * .toLowerCase() 字符串全小写
     * 原因 Object.prototype.toString.call(data) 获取精准对象类型 结果过为 [object Array]、[object string]、[object Object]
     * 所以需要最后一个单词就好
     */
    a = (_Object$prototype$toS = Object.prototype.toString.call(data)) === null || _Object$prototype$toS === void 0 || (_Object$prototype$toS = _Object$prototype$toS.replace(/\[|]/g, '')) === null || _Object$prototype$toS === void 0 || (_Object$prototype$toS = _Object$prototype$toS.split(' ')[1]) === null || _Object$prototype$toS === void 0 ? void 0 : _Object$prototype$toS.toLowerCase();
  }
  return a;
};